import { getById } from "@insite/client-framework/Store/Data/DataState";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";

export function getExpediteShippingStateById(state: ApplicationStateTKCCP, cartId: string | undefined) {
    return getById(state.expediteShipping, cartId);
}
